module.exports = __webpack_public_path__ + "static/media/nepal-logo.f1077183.png";